import { Font, StyleSheet, Text, View } from "@react-pdf/renderer"
import React from "react"
Font.register({
  family: "area-normal",
  fonts: [
    {
      src: "assets/learning/AreaNormal-Regular.otf"
    },
    {
      src: "assets/learning/AreaNormal-Bold.otf",
      fontWeight: "bold"
    },
    {
      src: "assets/learning/AreaNormal-Light.otf",
      fontWeight: "light"
    }
  ]
})

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: "row",
    marginTop: 4
  },
  reportTitle: {
    fontFamily: "area-normal",
    fontWeight: "bold",
    fontSize: 18,
    marginBottom: 4,
    marginTop: 4
  }
})

const Title = ({ title }) => (
  <View style={styles.titleContainer}>
    <Text style={styles.reportTitle}>{title}</Text>
  </View>
)

export default Title
